<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="12" md="12" class="mb-md-0 mb-2 text-capitalize">
            <validation-provider
              #default="validationContext"
              name="dvrs"
              rules="required"
            >
              <b-form-group
                :label="$tc('hanwha_dvr.title', 2)"
                label-for="dvrs"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  input-id="dvrs"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="dvrOptions"
                  class="w-100"
                  :reduce="(val) => val.value"
                  v-model="itemDataExtra.id_dvr"
                  @input="$emit('select-dvrs', $event)"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <div class="my-2">
            <b-row class="justify-content-end">
              <b-col cols="12" md="6">
                <b-form-input
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                  v-model="search"
                />
              </b-col>
            </b-row>
          </div>
          <b-table
            class="position-relative"
            :items="itemsData"
            responsive
            :fields="tableColumns"
            primary-key="id"
            show-empty
            :empty-text="$t('no_record_found')"
            :busy="isBusy"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>

            <template #head(cameraId)="data">
              <b-form-checkbox
                v-model="selectAll"
                inline
                v-b-tooltip.hover.bottom.viewport="$t(`alarm_views.btns.select_all`)"
                @input="selectAllCameras"
                :disabled="!itemsData.length"
              />
            </template>

            <template #head(Name)="data">
              <span> {{ $t(data.label) }}</span>
            </template>

            <template #head(Channel)="data">
              <span> {{ $t(data.label) }}</span>
            </template>

            <template #head(State)="data">
              <span> {{ $t(data.label) }}</span>
            </template>

            <template #head(is_fisheye)="data">
              <span> {{ $t(data.label) }}</span>
            </template>

            <template #head(send_to_seproban)="data">
              <span> {{ $t(data.label) }}</span>
            </template>

            <template #cell(cameraId)="data">
              <b-form-checkbox
                :id="`camera-${data.index}`"
                v-model="data.item.selected"
                :disabled="data.item.exists"
                @change="selectedCamera"
              />
            </template>

            <template #cell(Channel)="data">
              <div class="text-center">
                {{ Number(data.item.Channel) + 1 }}
              </div>
            </template>
          </b-table>
          <small
            v-if="showCamerasError"
            class="p-1"
            style="color: #ea5455"
          >
            El campo camaras es requerido
          </small>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BTable, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, computed } from "@vue/composition-api";
import Pagination from "@/components/Pagination.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    Pagination,
    ToastificationLoadingContent,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  props: {
    cameras: {
      type: Array
    },
    dvrOptions: {
      type: Array,
      default: null,
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    itemDataExtra: {
      type: Object
    }
  },

  setup(props, { emit }) {
    //COMPOSABLES
    const { refFormObserver, getValidationState } = formValidation();

    //DATA
    const search = ref('');

    const selectAll = ref(null);

    const showCamerasError = ref(false);

    //COMPUTED
    const itemsData = computed(() => {
      if (!search.value) {
        return props.cameras;
      }

      return props.cameras.filter((item) => {
        const textFilter = search.value.toLocaleLowerCase();

        return item.Name.includes(textFilter);
      }
    );
    });

    //METHODS
    const selectedCamera = () => {
      props.itemDataExtra.cameras = props.cameras.filter(camera => (camera.selected));
    }

    const selectAllCameras = () => {
      props.cameras.forEach(item => {
        item.selected = selectAll.value;
      });
      selectedCamera()
    }

    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Validation observer is not initialized");
        return false;
      }
      const validation = await refFormObserver.value.validate();
      return validation;
    }

    return {
      getValidationState,
      refFormObserver,

      tableColumns: [
        { label: "", key: "cameraId", sortable: false },
        { label: "hanwha_camera.name", key: "Name" },
        { label: "hanwha_camera.channel", key: "Channel" },
        { label: "hanwha_camera.state", key: "State" }
      ],
      itemsData,
      showCamerasError,

      search,
      selectAll,
      selectedCamera,
      validateStep,
      selectAllCameras
    }
  }
}
</script>
